import { FC, useContext } from "react";
import { PharmacyDetails } from "@/constants/routes";
import PharmacyResultsContentItem from "../PharmacyResultsContentItem";
import { PharmacyResultsListProps } from "./PharmacyResultsList.props";
import { ThemeSelectorContext } from "@/context/index";
import { PharmacyResultsCard } from "../PharmacyResultsCard";

import styles from "./PharmacyResultsList.module.scss";

const PharmacyResultsList: FC<PharmacyResultsListProps> = ({ pharmacyResults }: PharmacyResultsListProps) => {
  const { client } = useContext(ThemeSelectorContext);
  const linkTo = client ? `/client/${client}${PharmacyDetails}` : `${PharmacyDetails}`;

  const wrapperClassname = client ? styles.FindBestPricePharmacyResultsWhitelabel : "";

  return (
    <div className={wrapperClassname}>
      {pharmacyResults?.map((pharmacyResult, idx: number) => {
        const { pharmacy, price, distance } = pharmacyResult;
        const pharmacyData = pharmacy?.provider_id;
        const pharmacyAddress = pharmacyResult?.pharmacy;
        const address = pharmacyData ? `${pharmacyAddress.address_line_1}, ${pharmacyAddress.address_line_2}` : "";
        const cityStateZip = pharmacyData ? `${pharmacyAddress.city}, ${pharmacyAddress.state} ${pharmacyAddress.zip.slice(0, 5)}` : "";
        const isMaxUsualAndCustomaryCharge = pharmacyResult.is_max_usual_and_customary_charge;

        if (pharmacyData) {
          return (
            <PharmacyResultsCard
              key={idx}
              price={price}
              providerId={pharmacy.provider_id}
              distance={distance.toString()}
              priceUnavailableText="Check at Pharmacy"
              isMaxUsualAndCustomaryCharge={isMaxUsualAndCustomaryCharge}
              linkTo={linkTo}
              priceButtonClassname={client ? styles.FindBestPricePharmacyResultsWhitelabelButton : ""}
            >
              <PharmacyResultsContentItem
                address={address}
                cityStateZip={cityStateZip}
                distance={distance}
                pharmacyName={pharmacy.name}
                testId={`pharmacy-card-${pharmacy.name}`}
              />
            </PharmacyResultsCard>
          );
        }
      })}
    </div>
  );
};

export default PharmacyResultsList;
